
import _BaseController from 'Controllers/User/_BaseController';

export default class extends _BaseController {

    ready() {
        super.ready();
    }
}